import { iconFileDown } from "@kensho/icons";
import { Button } from "@kensho/neo";
import { useParams } from "react-router";

import { useTranscriptContext } from "../../../providers/use-transcript-context";
import { downloadFile } from "../../../utils/download-file";
import { snakeCaseDeep } from "../../../utils/snake-case-deep";

export function ExportLocalTranscriptButton() {
  const { transcript } = useTranscriptContext();
  const { transcriptId } = useParams();

  return (
    <Button
      icon={iconFileDown}
      onClick={() => {
        downloadFile(
          `${transcriptId}.json`,
          JSON.stringify(snakeCaseDeep(transcript)),
        );
      }}
    >
      Export transcript
    </Button>
  );
}
